import Service from '../abstract/service'

export default class Papeis extends Service {
  constructor() {
    super()
    this._papeisCollection = this._db.collection(`${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Papeis`)
  }

  async list() {
    try {
      let papeis = new Array()
      const response = await this._papeisCollection.get()

      if(!response.empty) {
        for(let doc of response.docs) {
          papeis.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(papeis)
    } catch(error) {
      return Promise.reject(error)
    }
  }

  async insert(nome) {
    try{
      await this._papeisCollection.doc(nome).set({
        nome: nome,
        ativo: true,
        dataCadastro: new Date()
      })
      return Promise.resolve()
    }catch(error){
      return Promise.reject(error)
    }
  }

  async updateAcessos(papel, acessos)
  {
    try
    {
      let papelRef = await this._papeisCollection.doc(papel)
      await papelRef.update({
        acessos: acessos
      })
      return Promise.resolve()
    }
    catch(error)
    {
      return Promise.reject(error)
    }
  }

  async getAcessos(papel)
  {
    try
    {
      let papelRef = await this._papeisCollection.doc(papel)
      let papelDoc = await papelRef.get()
      let papelData = papelDoc.data()

      return Promise.resolve(papelData.acessos)
    }
    catch(error)
    {
      return Promise.reject(error)
    }
  }
}
